import { call, put, takeEvery } from 'redux-saga/effects';

import typeActions from 'redux/typeActions';
import ServiceBase from 'services/ServiceBase';
import ServiceURL from 'services/ServiceURL';

export function* compareFiles(data) {
  const { payload, callback } = data;
  try {
    const formData = new FormData();
    if (payload?.excel1) formData.append('excel1', payload.excel1);
    if (payload?.excel2) formData.append('excel2', payload.excel2);
    if (payload?.pdf1) formData.append('pdf1', payload.pdf1);
    if (payload?.pdf2) formData.append('pdf2', payload.pdf2);

    const res = yield call(ServiceBase.POST_FILE, ServiceURL.compare, formData);

    yield put({
      type: typeActions.COMPARE_FILES_SUCCESS,
      data: res,
    });
    !!callback?.success && callback.success(res);
  } catch (error) {
    const detail =
      error?.response?.data?.detail ??
      error?.response?.data?.error?.message ??
      error?.message ??
      '';
    const mess =
      typeof detail === 'string' ? detail : JSON.stringify(detail ?? '');

    yield put({
      type: typeActions.COMPARE_FILES_FAILED,
      error: mess,
    });
    !!callback?.failed && callback.failed(mess);
  }
}

export default function* compareFilesSaga() {
  yield takeEvery(typeActions.COMPARE_FILES_REQUEST, compareFiles);
}

